export class Ubigeo {
    constructor({
        ubigeo = null,
        departmentCode = null,
        provinceCode = null,
        districtCode = null,
        department = null,
        province = null,
        district = null,
    } = {}) {
        this.ubigeo = ubigeo;
        this.departmentCode = departmentCode;
        this.provinceCode = provinceCode;
        this.districtCode = districtCode;
        this.department = department;
        this.provice = province;
        this.district = district;
        this.location = `${district} | ${department} | ${province}`;
    }
}
